import { render, staticRenderFns } from "./ClientWithoutCalling.vue?vue&type=template&id=a144b33e&scoped=true&"
import script from "./ClientWithoutCalling.vue?vue&type=script&lang=js&"
export * from "./ClientWithoutCalling.vue?vue&type=script&lang=js&"
import style0 from "./ClientWithoutCalling.vue?vue&type=style&index=0&id=a144b33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a144b33e",
  null
  
)

export default component.exports